import { useNavigate } from 'react-router-dom';
import { Context } from '../../AuthContext';
import styles from './Auth.module.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SubmitButton from './SubmitButton';
import { useState, useContext } from 'react';

const DescribeRole = () => {
  const [submitting, setSubmitting] = useState(false);
  const { user } = useContext(Context);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const formData = new FormData(e.target);
    const roleDescription = formData.get('roleDescription');
    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'edit_user';
    const token = await user.getIdToken();
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ roleDescription: roleDescription }),
    });

    // setSubmitting(false);
    navigate('/select-plan');
  };

  return (
    <div>
      <h2>
        Your role is <span style={{ color: '#356AC3' }}>Other</span>
      </h2>
      <p style={{ fontWeight: '500', fontSize: '20px', marginBottom: 0 }}>
        please write a brief description
      </p>
      <p className={styles.roleDescription} style={{ textAlign: 'center' }}>
        * You can add the role description in your account anytime later
      </p>
      <form
        onSubmit={onSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          minWidth: '50%',
          margin: '0 auto',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <span style={{ fontWeight: '700' }}>Skip*&nbsp;&nbsp;</span>
          <ArrowForwardIcon
            className={styles.skipButton}
            fontSize="small"
            onClick={() =>
              (navigate('/select-plan'))
            }
          />
        </div>

        <textarea className="input-text" name="roleDescription" rows={8} />

        <div className={styles.footer}>
          <SubmitButton text="Continue" width="25%" height="48px" disabled={submitting} />
        </div>
      </form>
    </div>
  );
};
export default DescribeRole;
